"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSubscriptionsForCurrentUser = void 0;
var _immutable = require("immutable");
var _luxon = require("luxon");
var _reselect = require("reselect");
var subscriptionMap = function subscriptionMap(subscription) {
  var infinite = Math.floor(_luxon.DateTime.fromMillis(subscription.get('activation_date', 0)).diff(_luxon.DateTime.fromMillis(subscription.get('expiry_date', 0)), ['years']).toObject().years) <= -100;
  var organizational = subscription.get('organization_id') && !subscription.get('product_id');
  var type = organizational ? 'OrganizationalSubscription' : 'ConsumerSubscription';
  return subscription.merge({
    organizational: organizational,
    type: type,
    infinite: infinite
  });
};

/* selectSubscriptionsForCurrentUser()
 *
 * Returns a List of the current User's ConsumerSubscriptions and active/verified OrganizationalSubscriptions as Subscriptions.
 */
var selectSubscriptionsForCurrentUser = exports.selectSubscriptionsForCurrentUser = (0, _reselect.createSelector)([function (state) {
  return state.session.get('current_user_id');
}, function (state) {
  return state.subscriptions;
}, function (state) {
  return state.organizationalMemberships;
}, function (state) {
  return state.organizations;
}, function (state) {
  return state.organizationalSubscriptions;
}], function (userId, subscriptions, organizationalMemberships, organizations, organizationalSubscriptions) {
  if (!userId) return new _immutable.List();

  // Get all ConsumerSubscriptions for current user and convert them to Subscriptions
  var filteredSubscriptions = subscriptions.toList().filter(function (subscription) {
    return subscription.get('user_id') === userId;
  });
  var convertedConsumerSubscriptions = filteredSubscriptions.map(function (subscription) {
    return subscriptionMap(subscription);
  });

  // Get all OrganizationalSubscriptions for current user and convert them to Subscriptions
  var filteredOrganizationalMemberships = organizationalMemberships.toList().filter(function (membership) {
    return membership.get('user_id') === userId && !membership.get('deactivated') && membership.get('verified');
  });
  var convertedOrganizationalSubscriptions = organizations.filter(function (org) {
    return filteredOrganizationalMemberships.some(function (membership) {
      return membership.get('organization_id') === org.get('id');
    });
  }).reduce(function (accumulator, organization) {
    var organizationSubscriptions = organizationalSubscriptions.toList().filter(function (subscription) {
      return organization.get('organizational_subscription_ids').includes(subscription.get('id'));
    });

    // OrganizationalSubscriptions have many QuestionBanks so we need to flatten all of them into single-QB Subscriptions
    var convertedOrganizationSubscriptions = organizationSubscriptions.reduce(function (accumulator2, subscription) {
      var organizationalMembership = filteredOrganizationalMemberships.find(function (membership) {
        return membership.get('organization_id') === organization.get('id');
      });
      var subscriptionsForOrganization = subscription.get('question_bank_ids').map(function (questionBankId) {
        return subscriptionMap(subscription.set('organization_id', organization.get('id')).set('question_bank_id', questionBankId).set('organization_restricted', organizationalMembership.get('role') === 'student' && organization.get('visible_banks') === 'none').set('hide_cme', organization.get('hide_cme')));
      });
      return accumulator2.concat(subscriptionsForOrganization);
    }, new _immutable.List());
    return accumulator.concat(convertedOrganizationSubscriptions);
  }, new _immutable.List());

  // Return all results together
  return convertedConsumerSubscriptions.concat(convertedOrganizationalSubscriptions);
});